import { Partner } from "@/model/Partner";
import { MaklerRabatt } from "@/model/MaklerRabatt";

export class Vermittlerdaten extends Partner {
  vermittlernummer = "";
  vermittlerstatus = "";
  verbundzuordnung = "";
  ihkRegistrierung = "";
  iban = "";
  maklerRabatte: MaklerRabatt[];

  constructor() {
    super();
    this.maklerRabatte = [];
  }
}
